import { API } from '../config/config';

const PayrollService = {
  listHolidays: (storeId) => listHolidays(storeId),
  getHoliday: (storeId, id) => getHoliday(storeId, id),
  createHoliday: (storeId, payload) => createHoliday(storeId, payload),
  updateHoliday: (storeId, id, payload) => updateHoliday(storeId, id, payload),
  deleteHoliday: (storeId, id) => deleteHoliday(storeId, id),

  listAdjustments: (storeId, params = {}) => listAdjustments(storeId, params),
  getAdjustment: (storeId, id) => getAdjustment(storeId, id),
  createAdjustment: (storeId, payload) => createAdjustment(storeId, payload),
  updateAdjustment: (storeId, id, payload) => updateAdjustment(storeId, id, payload),
  deleteAdjustment: (storeId, id) => deleteAdjustment(storeId, id),
};

const normalizeArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
};

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.append(key, value);
  });
  const qs = query.toString();
  return qs ? `?${qs}` : '';
};

const listHolidays = async (storeId) => {
  try {
    const response = await API.get(`/stores/${storeId}/payroll/holidays`);
    return normalizeArray(response.data);
  } catch (err) {
    console.error('Error fetching holidays:', err);
    throw err;
  }
};

const getHoliday = async (storeId, id) => {
  try {
    const response = await API.get(`/stores/${storeId}/payroll/holidays/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error fetching holiday:', err);
    throw err;
  }
};

const createHoliday = async (storeId, payload) => {
  try {
    const response = await API.post(`/stores/${storeId}/payroll/holidays`, payload);
    return response.data;
  } catch (err) {
    console.error('Error creating holiday:', err);
    throw err;
  }
};

const updateHoliday = async (storeId, id, payload) => {
  try {
    const response = await API.put(`/stores/${storeId}/payroll/holidays/${id}`, payload);
    return response.data;
  } catch (err) {
    console.error('Error updating holiday:', err);
    throw err;
  }
};

const deleteHoliday = async (storeId, id) => {
  try {
    const response = await API.delete(`/stores/${storeId}/payroll/holidays/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error deleting holiday:', err);
    throw err;
  }
};

const listAdjustments = async (storeId, params = {}) => {
  try {
    const response = await API.get(`/stores/${storeId}/payroll/adjustments${buildQuery(params)}`);
    return normalizeArray(response.data);
  } catch (err) {
    console.error('Error fetching payroll adjustments:', err);
    throw err;
  }
};

const getAdjustment = async (storeId, id) => {
  try {
    const response = await API.get(`/stores/${storeId}/payroll/adjustments/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error fetching payroll adjustment:', err);
    throw err;
  }
};

const createAdjustment = async (storeId, payload) => {
  try {
    const response = await API.post(`/stores/${storeId}/payroll/adjustments`, payload);
    return response.data;
  } catch (err) {
    console.error('Error creating payroll adjustment:', err);
    throw err;
  }
};

const updateAdjustment = async (storeId, id, payload) => {
  try {
    const response = await API.put(`/stores/${storeId}/payroll/adjustments/${id}`, payload);
    return response.data;
  } catch (err) {
    console.error('Error updating payroll adjustment:', err);
    throw err;
  }
};

const deleteAdjustment = async (storeId, id) => {
  try {
    const response = await API.delete(`/stores/${storeId}/payroll/adjustments/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error deleting payroll adjustment:', err);
    throw err;
  }
};

export default PayrollService;
